import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { prismicImage } from 'src/common/utils/prismic-image';
import Panel from 'wonderbly-components/lib/Panel';
import ClipboardText from '../CopyToClipboard/CopyToClipboard';
import './Offer.scss';

const Offer = props => {
  const { title, image, description, offerCtaText, offerCode, copiedNotificationText, isLayoutHorizontal } = props;
  let backgroundImage = prismicImage(image);

  if (isLayoutHorizontal) {
    backgroundImage = prismicImage(image.square);
  }

  return (
    <Panel className={cx('offer-panel', {
      'offer-panel---horizontal': props.isLayoutHorizontal,
    })} border="shadow">
      {image &&
        <div
          className="offer-image"
          style={{ backgroundImage: `url("${backgroundImage}")` }}
        />
      }
      <div className="offer-content">
        {title &&
          <h5 className="text-kilo bold">{title}</h5>
        }
        {description &&
          <p className="text-base">{description}</p>
        }
        {offerCtaText && offerCode &&
          <ClipboardText
            value={offerCode}
            text={offerCtaText}
            successText={copiedNotificationText}
          />
        }
      </div>
    </Panel>
  );
};

Offer.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  image: PropTypes.object.isRequired,
  offerCtaText: PropTypes.string,
  copiedNotificationText: PropTypes.string,
  offerCode: PropTypes.string,
  isLayoutHorizontal: PropTypes.bool,
};

export default Offer;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Offer/Offer.js